import { useLang } from '@/i18n';
import EfBanner from '@elem/ui/ef-banner';
import { useRouter } from 'next/router';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph', 'nl'].includes(locale);
    const { pageStatus } = useProductStore();

    const youtubeLocal = {
        // us: 'https://www.youtube.com/embed/gtxAkmNxMH8?si=MSicapOQhBWL8Dw-',
        us: 'https://www.youtube.com/embed/J4iuggnpDpA?si=sekc-GwxD8flCWlS',
        jp: 'https://www.youtube.com/embed/kXWVSY6Lk6s?si=Pei_-mdtUsFHaKK5',
        uk: 'https://www.youtube.com/embed/ugH9SzPHTcI',
        de: 'https://www.youtube.com/embed/fyPfs1F0poA',
        fr: 'https://www.youtube.com/embed/8wmCRfUWGjE',
        it: 'https://www.youtube.com/embed/00cwjm7VMKA',
        es: 'https://www.youtube.com/embed/bnY-G4NCqME',
        eu: 'https://www.youtube.com/embed/ugH9SzPHTcI',
    };
    const imgNA = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724641466526/KV1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724641466714/M_KV.jpg',
    };
    const imgJP = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723601157919/KV.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723601181632/M_KV.jpg',
    };
    const imgEU = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725087318003/euPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725087317665/euH1.jpg',
    };
    const imgUK = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725087317500/ukPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725087317836/ukH1.jpg',
    };
    const imgPH = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1750994802356/KV_ph.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1750994802617/M_KV_ph.jpg',
    };
    const imgAll: any = {
        us: imgNA,
        ca: imgNA,
        br: imgNA,
        mx: imgNA,
        jp: imgJP,
        eu: imgEU,
        uk: imgUK,
        de: imgEU,
        fr: imgEU,
        it: imgEU,
        nl: imgEU,
        es: imgEU,
        ph: imgPH,
    };
    const imgObj = imgAll[locale] || imgAll['us'];
    const NA_StatusA = IS_NA_SITES && pageStatus === 'statusA';
    const EU_StatusA = IS_EU_SITES && pageStatus === 'statusA';
    const configs = {
        label: t('A_label'),
        title: t('A_title'),
        desc: t('A_desc'),
        pc: imgObj.pc,
        h5: imgObj.h5,
        // theme: 'white',
        btn_text: NA_StatusA || EU_StatusA ? '' : t('A_btn'),
        btn_link: NA_StatusA || EU_StatusA ? '' : youtubeLocal[locale] || youtubeLocal['us'],
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...configs} />
        </div>
    );
}
